let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cUlxg")).then(() => parcelRequire('44Ret'));